module.exports = __webpack_public_path__ + "static/img/编组4.3335c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ccc/编组4.png
// module id = 14OD
// module chunks = 8